import React from 'react';

export const FlowMeter = (props) => (
    <svg {...props} viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 11.5H28.9C28.2 5 22.7 0 16 0C9.3 0 3.8 5 3.1 11.5H0V14.5H3.1C3.8 21 9.3 26 16 26C22.7 26 28.2 21 28.9 14.5H32V11.5ZM16 23C10.5 23 6 18.5 6 13C6 7.5 10.5 3 16 3C21.5 3 26 7.5 26 13C26 18.5 21.5 23 16 23ZM19.5 9.5C21.5 11.5 21.5 14.6 19.5 16.6C17.5 18.6 14.4 18.6 12.4 16.6C10.4 14.6 10.4 11.5 12.4 9.5L16 5.9L19.5 9.5Z" />
    </svg>
);

export default FlowMeter;
